import * as http from 'gs-browser-http';
import { cfg } from '../config';

const url = cfg.apiUrlBase + `/api/rest/v1/theme/geocode/dataset_vector/uk.pc/data/search/{"operator":"like","value":"{{needle}}","key":"test"}`;

export interface PostcodeSearchResponse {
    type: "FeatureCollection", features: {
        type: "Feature",
        properties: { postcode: string },
        geom: {
            type: "Point", coordinates: [number, number]
        }
    }[]
}

class ProviderSearch {

    constructor() { }

    public postcode(needle: string): Promise<PostcodeSearchResponse> {
        return http.GET(url.replace('{{needle}}', needle)).then(r => {
            let content: PostcodeSearchResponse = JSON.parse(r.data);
            return content;
        });
    }
}

export let providerSearch = new ProviderSearch();